module.exports = __webpack_public_path__ + "img/exchangeLimits4x.9777d707.png";